var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeadphonesSupport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 10C17.5031 14.1439 14.1439 17.5031 10 17.5031",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49689 10.0001C2.49689 5.85621 5.85615 2.49695 10 2.49695",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49689 10C2.497 10.8789 2.65332 11.7508 2.95855 12.5749C3.09814 12.9577 3.4917 13.1857 3.89319 13.1164L4.71535 12.9714C5.37986 12.8542 5.83158 12.231 5.73615 11.563L5.4887 9.83086C5.44079 9.49553 5.2589 9.19399 4.98463 8.9952C4.71037 8.79641 4.36719 8.71739 4.0336 8.77621L2.56583 9.03501",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 10.0001C17.5031 5.85621 14.1439 2.49695 10 2.49695",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5031 10C17.503 10.8789 17.3467 11.7508 17.0415 12.5749C16.9019 12.9577 16.5083 13.1857 16.1068 13.1164L15.2847 12.9714C14.6202 12.8542 14.1684 12.231 14.2639 11.563L14.5113 9.83086C14.5592 9.49553 14.7411 9.19399 15.0154 8.9952C15.2897 8.79641 15.6328 8.71739 15.9664 8.77621L17.4342 9.03501",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeadphonesSupport);
export default ForwardRef;